import { Avatar, Box, Paper } from "@mui/material";
import Home2 from "iconsax-reactjs/dist/esm/Home2.js";
import InfoCircle from "iconsax-reactjs/dist/esm/InfoCircle.js";
import Add from "iconsax-reactjs/dist/esm/Add.js";
import SearchNormal1 from "iconsax-reactjs/dist/esm/SearchNormal1.js";
import LoginCurve from "iconsax-reactjs/dist/esm/LoginCurve.js";
import MessageText1 from "iconsax-reactjs/dist/esm/MessageText1.js";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openAuthModal } from "../../../../store/Slice/reducers";

export const BOTTOM_NAV_HEIGHT = 64;
export const BOTTOM_NAV_TOTAL_OFFSET = 92;

const leftItems = [
  { href: "/", label: "خانه", Icon: Home2 },
  { href: "/about", label: "درباره", Icon: InfoCircle },
];
const rightItems = [{ href: "/blog", label: "بلاگ", Icon: MessageText1 }];

const NavItem = ({ href, label, Icon, active, onNavigate }) => (
  <Box
    onClick={(e) => {
      e.preventDefault();
      onNavigate(href);
    }}
    sx={{
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.4,
      textDecoration: "none",
      cursor: "pointer",
      minWidth: 46,
      py: 0.5,
    }}
  >
    {active && (
      <Box
        sx={{
          position: "absolute",
          inset: "-4px -10px",
          borderRadius: "14px",
          bgcolor: "primary.main",
          zIndex: 0,
        }}
      />
    )}
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        transition: "transform .15s ease",
        "&:active": { transform: "scale(0.9)" },
      }}
    >
      <Icon
        size={20}
        variant={active ? "Bold" : "Outline"}
        color={active ? "#fff" : undefined}
        style={{ color: active ? "#fff" : "var(--icon-color, inherit)" }}
      />
      <Box
        component="span"
        sx={{
          fontSize: 10.5,
          fontWeight: 600, // constant weight — no width jitter on activate
          lineHeight: 1,
          color: active ? "#fff" : "text.secondary",
        }}
      >
        {label}
      </Box>
    </Box>
  </Box>
);

export default function BottomNav({ isAuthenticated }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { user, role } = useSelector((state) => state.userSlice);

  const go = (href) => navigate(href);

  const isProvider = role == "provider";
  const centerHref = isProvider ? "/finding-project" : "/services/category";
  const CenterIcon = isProvider ? SearchNormal1 : Add;
  const centerActive = pathname === centerHref;

  return (
    <Paper
      elevation={0}
      sx={{
        display: { xs: "flex", sm: "none" },
        alignItems: "center",
        position: "fixed",
        bottom: "calc(14px + env(safe-area-inset-bottom))",
        left: 14,
        right: 14,
        height: BOTTOM_NAV_HEIGHT,
        borderRadius: "24px",
        overflow: "visible",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        bgcolor: "rgba(255,255,255,0.86)",
        border: "1px solid rgba(255,255,255,0.9)",
        boxShadow:
          "0 1px 0 rgba(255,255,255,.8) inset, 0 18px 38px -16px rgba(15,23,42,.28)",
        px: 2,
        zIndex: 200,
      }}
    >
      <Box sx={{ display: "flex", flex: 1, justifyContent: "space-evenly" }}>
        {leftItems.map((item) => (
          <NavItem
            key={item.href}
            {...item}
            active={pathname === item.href}
            onNavigate={go}
          />
        ))}
      </Box>

      <Box sx={{ width: 56 }} />

      <Box sx={{ display: "flex", flex: 1, justifyContent: "space-evenly" }}>
        {rightItems.map((item) => (
          <NavItem
            key={item.href}
            {...item}
            active={pathname === item.href}
            onNavigate={go}
          />
        ))}

        {isAuthenticated ? (
          <NavItem
            href="/profile/details"
            label="پروفایل"
            active={pathname.startsWith("/profile")}
            onNavigate={go}
            Icon={() => (
              <Avatar
                src={import.meta.env.VITE_FILE_API + user?.profileImg}
                alt={user?.fullname || "کاربر"}
                sx={{
                  width: 20,
                  height: 20,
                  fontSize: 9,
                  fontWeight: 700,
                  bgcolor: pathname.startsWith("/profile")
                    ? "#fff"
                    : "primary.main",
                  color: pathname.startsWith("/profile")
                    ? "primary.main"
                    : "#fff",
                }}
              >
                {user?.fullname?.at(0) || "؟"}
              </Avatar>
            )}
          />
        ) : (
          <Box
            onClick={(e) => {
              e.preventDefault();
              dispatch(openAuthModal("login"));
            }}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.4,
              color: pathname === "/login" ? "primary.main" : "text.secondary",
              cursor: "pointer",
            }}
          >
            <LoginCurve size={20} />
            <Box component="span" sx={{ fontSize: 10.5, fontWeight: 600 }}>
              ورود
            </Box>
          </Box>
        )}
      </Box>

      {/* Positioning wrapper: plain element, static transform, NEVER
          touched by Framer Motion — this is what stops the FAB jumping. */}
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: -24,
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          onClick={() => go(centerHref)}
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "transform .15s ease",
            "&:active": { transform: "scale(0.9)" },
            background: "linear-gradient(135deg, #FF8A5B 0%, #FF6B35 100%)",
            boxShadow: centerActive
              ? "0 0 0 3px #fff, 0 0 0 6px #FF6B35, 0 12px 26px -6px rgba(255,107,53,.65)"
              : "0 0 0 6px #fff, 0 10px 22px -8px rgba(255,107,53,.5)",
          }}
        >
          <CenterIcon size={23} color="#fff" variant="Bold" />
        </Box>

        <Box
          component="span"
          sx={{
            fontSize: 10.5,
            fontWeight: 600,
            lineHeight: 1,
            color: centerActive ? "secondary.main" : "text.secondary",
            // pulls the label back up toward the pill, since the FAB
            // itself already carries a lot of the vertical gap via `top: -24`
            mt: -0.5,
          }}
        >
          {isProvider ? "پروژه‌ها" : "ثبت درخواست"}
        </Box>
      </Box>
    </Paper>
  );
}
